module.exports = __webpack_public_path__ + "img/ch_airdrop.d3bbaf61.png";